class StickyBar {
  constructor(el) {
    this.element = el;
    this.buffer = parseInt(el.dataset.buffer);
    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener(`scroll`, () => {
      if (window.scrollY > this.buffer) {
        this.element.classList.add(`sticky-bar--in-view`);
      } else {
        this.element.classList.remove(`sticky-bar--in-view`);
      }
    });
  }
}
document.addEventListener(`DOMContentLoaded`, () => {
  document.querySelectorAll(`[data-sticky-bar]`).forEach(el => new StickyBar(el));
});